import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import "./App.css";
import Student from "./Components/Student/Student";
import Sidebar from "./Components/Sidebar/Sidebar";
import Studentdetail from "./Components/Student/Studentdetail";
import EmailCouponTransactions from "./Components/StudentReferral/studentReferral";
import Studentcommission from "./Components/Student/Studentcommission";
import Term from "./Components/Student/Term";
import Discount from "./Components/Student/Discount";

import awsExports from "./aws-exports";
Amplify.configure(awsExports);

function App() {
  return (
    <Authenticator>
      {({ signOut, user }) => {
        const email =
          user?.signInDetails?.loginId ||
          user?.attributes?.email ||
          user?.username ||
          "";

        return (
          <Router>
            <div className="topbar">
              <span>
                Logged in as : <strong>{email}</strong>
              </span>
              <button className="btn-signout" onClick={signOut}>
                Sign Out
              </button>
            </div>

            <div className="app-shell">
              <Sidebar />

              <main className="content">
                <Routes>
                  <Route path="/Discount" element={<Discount />} />
                  <Route path="/Term" element={<Term />} />
                  <Route path="/" element={<Student email={email} />} />
                  <Route path="/student" element={<Student email={email} />} />

                  <Route
                    path="/Studentcommission"
                    element={<Studentcommission email={email} />}
                  />
                  <Route
                    path="/Studentdetail"
                    element={<Studentdetail email={email} />}
                  />
                  <Route
                    path="/email-coupon-transactions"
                    element={<EmailCouponTransactions email={email} />}
                  />
                </Routes>
              </main>
            </div>
          </Router>
        );
      }}
    </Authenticator>
  );
}

export default App;
